import { empty as observableEmpty,
         Observable,
         throwError as observableThrowError,
         BehaviorSubject, 
         firstValueFrom,
         of } from 'rxjs'

import { catchError,
         distinctUntilChanged,
         map } from 'rxjs/operators'

import { Injectable } from '@angular/core'

import { ApiService } from './api.service'

import { User } from '../_models/user.model'
import { HttpParams } from '@angular/common/http'

import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class UserService {

  private selectedUserSubject = new BehaviorSubject<User>(null)
  public selectedUser = this.selectedUserSubject.asObservable().pipe(distinctUntilChanged())
  private selectedUserLocal: User

  constructor (
    private apiService: ApiService,
    private matSnackbar: MatSnackBar
  ) {}

  userFromData(data: any): User {
    // console.log('entryFromData', data, updateSelectedEntry)
    if (!data) return
    if (data['error'] === 'pundit') { console.warn('err: userFromData-pundit', data['error']); return data }
    let user = new User(data)
    return user
  }

  shouldUpdateSelectedUser(user: User, updateSelectedUser: boolean) {
    if (updateSelectedUser) return true
    if (!this.selectedUserLocal) return false
    if (user.id === this.selectedUserLocal['id']) return true
    return false
  }

  updateSelectedUser(user:User): any {
    this.selectedUserSubject.next(user)
    this.selectedUserLocal = user
    return user
  }

  // getUser(id: string): Observable<User> {
  //   return this.apiService.get('users/' + id).pipe(
  //       catchError(err => this.handleError(err) ),
  //       map( (res: User) => this.userFromData(res)
  //   ))
  // }
  
  async getUsers(params:any = {}): Promise<User[]> {
    let url = 'users'

    let routeParams = new HttpParams()
      .set('page', params['page'])
      .set('limit', params['limit'])
      .set('sortBy', params['sortBy'])  // : {}


    return firstValueFrom(this.apiService.get(url, routeParams).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: User[]) => {
        res['results'] = res['results'].map(u => new User(u)) 
        return res
      }) // this.userFromData(res)
    ))
  }

  async findUserBy(params:any = {}): Promise<User> {
    let url = 'users/find'
    return firstValueFrom(this.apiService.post(url, params).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: User) => this.userFromData(res)
    )))
  }

  // Update the user on the server
  // TODO: DTO instead of raw user
  update(user: User): Observable<User> {
    return this.apiService
      .put('users/' + user.id, user)
      .pipe(map(data => {
        return this.userFromData(data)
      }))
  }

  // TODO: DTO instead of raw user
  create(user: User): Observable<User> {
    // console.log('creating user?', user)
    
    return this.apiService
      .post('users/create', user)
      .pipe(
        catchError(err => this.handleError(err) ),
        map(data => {
          console.log('new-user-data', data)
          return this.userFromData(data)
        }));
  }

  delete(user: User): Observable<User> {
    // console.log('TODO: delete user', user)
    return this.apiService
      .post('users/' + user.id + '/delete')
      .pipe(map(data => {
        // console.log('DELETED', user)
        return data
        return this.userFromData(data)
      }))
  }

  handleError(err: any) {
    console.warn('ERR: user.service handled', err)
    this.matSnackbar.open(`ERROR: ${err.message}`, 'close', { duration: 5000 });
    if (!err) return Promise.reject()
    return observableThrowError(err)
  }

}
